
import React from 'react';
import { paymentList } from 'Utils/Helpers/TableColumns';
import DataGridComponent from 'Utils/Helpers/DataGridComponent';
import { TextShow } from 'Utils/Helpers/TextShow';

export default function Payments({ data, close, patient = false }) {
  return (
    <>
      {
        (data.paymentList && data.paymentList.length !== 0)
        ? <div className="w-100 mb-4 text-center">
          <DataGridComponent
              data={data.paymentList.map(i => {
                return {
                  ...i,
                  patient: patient ? true : false,
                };
              })}
              columns={paymentList}
              rowHeight={40}
              className={'h-mini2'}
          />
        </div>
        :  <div className="w-100 mb-4">
          <p className='w-100 text-center text-muted'>موردی برای نمایش وجود ندارد</p>
        </div>
      }
    </>
  );
}
